export default function Footer() {
  return (
    <footer id="footer" className="bg-background-800 text-white">
      <div className="section-container py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span
              className="text-xl font-bold"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              <span className="text-primary-400">甜柚</span>漫画
            </span>
            <p className="text-sm text-white/50 mt-3 leading-relaxed">
              甜柚漫画汇聚甜宠恋爱、治愈校园纯爱、少女漫画，免费全集甜蜜漫画大全，日漫韩漫纯爱，好看停不下来。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap">首页</a>
              <a href="#ranking" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap">人气榜单</a>
              <a href="#media" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap">精彩推荐</a>
              <a href="#index" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap">分类导航</a>
              <a href="#updates" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap">最近更新</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">漫画分类</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-white/50">甜宠恋爱</span>
              <span className="text-sm text-white/50">校园纯爱</span>
              <span className="text-sm text-white/50">治愈漫画</span>
              <span className="text-sm text-white/50">奇幻恋爱</span>
              <span className="text-sm text-white/50">都市言情</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">合作伙伴</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-white/50">多家内容合作方</span>
              <span className="text-sm text-white/50">原创漫画平台</span>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; 2026 甜柚漫画网 - 甜蜜漫画大全，好看停不下来
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-white/40 hover:text-primary-400 transition-colors">首页</a>
            <a href="#contact" className="text-xs text-white/40 hover:text-primary-400 transition-colors">联系我们</a>
            <a href="#faq" className="text-xs text-white/40 hover:text-primary-400 transition-colors">常见问题</a>
            <a href="#about" className="text-xs text-white/40 hover:text-primary-400 transition-colors">关于甜柚</a>
          </div>
        </div>
      </div>
    </footer>
  );
}